import React from 'react';
import UseGetDashBoardDataPro from '../../../../Components/Hooks/UseGetDashBoardDataPro';

const Bids = () => {
  const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/bids/status`);

 

  return (
    <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full">
      <div className="text-center">
        <h2 className="font-semibold text-[#4F4768] text-sm">Bids</h2>
        <p className="text-[#3B2DB2] font-semibold">{data?.totalBids || 0}</p>
      </div>

      {[
        { label: "Submitted", key: "Submitted" },
        { label: "In-Process", key: "In-Process" },
        { label: "Awarded", key: "Awarded" },
        { label: "Not-Awarded", key: "Not-Awarded" },
        { label: "Closed", key: "Closed" },
      ].map(({ label, key }) => (
        <div key={key} className="flex w-full my-2 text-xs justify-between">
          <p className="text-[#4F4768]">{label}</p>
          <p className="text-[#007BEC] font-medium">{data?.status_counts?.[key] || 0}</p>
        </div>
      ))}
    </div>
  );
};

export default Bids;
